import { AppBar, Box, Toolbar } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { UpliftLogo } from '@uplift/icons';
import { Button } from '@uplift/ui-v2';
import { useFormLayoutStyles } from './form-layout-styles';

export type FormHeaderProps = {
  exitText?: string;
  onBackBtnClick?: () => void;
  onExit?: () => void;
};

export const FormHeader: React.VFC<FormHeaderProps> = props => {
  const { classes } = useFormLayoutStyles();

  return (
    <AppBar position="absolute" elevation={0} className={classes.headerWrapper}>
      <Toolbar className={classes.header}>
        <Box justifySelf="start">
          {props.onBackBtnClick && (
            <Button
              type="button"
              color="primary"
              startIcon={<ArrowBack />}
              onClick={props.onBackBtnClick}
              className={classes.headerButton}
            >
              Back
            </Button>
          )}
        </Box>
        <Box className={classes.logo}>
          <UpliftLogo />
        </Box>
        <Box justifySelf="end">
          {props.onExit && (
            <Button
              type="button"
              color="primary"
              onClick={props.onExit}
              className={classes.headerButton}
            >
              {props.exitText}
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
